import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useInAppHistoryStore } from '../../store/useInAppHistoryStore';

export const NavigationTracker: React.FC = () => {
  const history = useHistory();
  useEffect(() => {
    const unlisten = history.listen((_, action) => {
      if (action === 'PUSH') {
        useInAppHistoryStore.getState().recordPush();
      } else if (action === 'POP') {
        useInAppHistoryStore.getState().recordPop();
      }
    });
    return unlisten;
  }, [history]);
  return null;
};
